<template>
  <aside class="app-sidebar">
    <div class="app-sidebar__user text-center">
      <!-- Show user image -->
      <img v-if="account" class="mb-3" :src="`data:image/png;base64,${account.image}`" alt="User Image" width="100">
      <img v-else class="mb-3" src="@/assets/user.png" alt="User Image" width="120">
      <!-- Show user information if authenticated -->
      <div v-if="isAuthenticated">
        <p class="app-sidebar__user-name">{{ user.name }}</p>
        <p class="app-sidebar__user-designation">{{ account.job_position }}</p>
        <p class="app-sidebar__user-designation">
          <span v-if="account.department">{{ account.department.name }}</span>
        </p>
      </div>
    </div>

    <!-- Sidebar menu items -->
    <ul class="app-menu">
      <li>
        <router-link :to="{ name: 'dashboard' }" class="app-menu__item">
          <i class="bi bi-speedometer app-menu__icon"></i>
          <span class="app-menu__label">หน้าหลัก</span>
        </router-link>
      </li>

      <!-- Conditional rendering based on user role -->
      <div v-if="user && user.role === 'manager'">
        <li>
          <router-link :to="{ name: 'accounts' }" class="app-menu__item">
            <i class="app-menu__icon bi bi-people"></i>
            <span class="app-menu__label">ข้อมูลเจ้าหน้าที่</span>
          </router-link>
        </li>
      </div>

      <div v-if="user && user.role === 'admin'">
        <li>
          <router-link :to="{ name: 'accounts' }" class="app-menu__item">
            <i class="app-menu__icon bi bi-people"></i>
            <span class="app-menu__label">ข้อมูลเจ้าหน้าที่</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'ortherlinks' }" class="app-menu__item">
            <i class="app-menu__icon bi bi-share"></i>
            <span class="app-menu__label">โปรแกรมอื่นๆ</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'modules' }" class="app-menu__item">
            <i class="app-menu__icon bi bi-share"></i>
            <span class="app-menu__label">ระบบสารสนเทศ</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'accesses' }" class="app-menu__item">
            <i class="bi bi-laptop app-menu__icon"></i><span class="app-menu__label">แอปพลิเคชันเว็บ</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'users' }" class="app-menu__item">
            <i class="bi bi-person app-menu__icon"></i><span class="app-menu__label">ผู้ใช้งาน</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'roles' }" class="app-menu__item">
            <i class="bi bi-person-lock app-menu__icon"></i><span class="app-menu__label">สิทธิผู้ใช้งาน</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'departments' }" class="app-menu__item">
            <i class="bi bi-houses app-menu__icon"></i><span class="app-menu__label">หน่วยงาน</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'admin' }" class="app-menu__item">
            <i class="bi bi-person-lock app-menu__icon"></i><span class="app-menu__label">ผู้ดูแลระบบ</span>
          </router-link>
        </li>

        <!-- Treeview for hospital structures -->
        <li v-if="user && user.role === 'admin'" class="treeview">
          <router-link class="app-menu__item" to="" data-toggle="treeview">
            <i class="app-menu__icon bi bi-gear"></i>
            <span class="app-menu__label">กลุ่มงานตามกลุ่มภารกิจ</span>
            <i class="treeview-indicator bi bi-chevron-right"></i>
          </router-link>
          <ul class="treeview-menu">
            <li v-for="(item, index) in hospital_structures" :key="index">
              <!-- Use :to with the path directly -->
              <router-link class="app-menu__item" :to="`/groups/${item.id}`">
                <span class="app-menu__label"><small>{{ item.code }} {{ item.name }}</small></span>
              </router-link>
            </li>
          </ul>
        </li>
      </div>
    </ul>
  </aside>
</template>

<script>
import hospitalStructuresService from '@/services/hospital-structures-service';
import usersService from '@/services/users-service';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      account: {},
      hospital_structures: [],
    };
  },
  methods: {
    // Fetch hospital structures from API
    async fetchHospitalStructures() {
      try {
        const res = await hospitalStructuresService.getAll();
        // this.hospital_structures = res.data;
        this.hospital_structures = res.data.filter(item => ![1, 2, 3, 4].includes(item.id));

      } catch (error) {
        this.showError(error);
      }
    },
    // Log out the user
    logout() {
      this.$store.dispatch('logout');
    },
    // Fetch user data by ID
    async getUser(id) {
      try {
        const res = await usersService.get(id);
        this.account = res.data.account;
      } catch (error) {
        this.showError(error);
        localStorage.removeItem('vuex');
      }
    },
  },
  mounted() {
    this.fetchHospitalStructures();
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    ...mapState(['app', 'user']),
  },
  created() {
    this.getUser(this.user.id);
  },
};
</script>

<style scoped>
.app-sidebar__user {
  display: block;
  margin-bottom: 0px;
}
</style>
